module.exports = __webpack_public_path__ + "img/icon_card6.cf5a3088.png";